/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './BookingsList.scss';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
// import BookingsListCard from './BookingsListCard';

import { debounce } from '../../../api/apiUtils';
import HotelBookingsListCard from './HotelBookingsListCard';

const CONFIRM = 'CONFIRM';
const CANCELLED = 'CANCELLED';
const ONHOLD = 'ONHOLD';
const ROLLEDBACK = 'ROLLEDBACK';

function BookingsList({ hotelBookings }) {
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState([]);
  const [confirmedBookingsList, setConfirmedBookingsList] = useState([]);
  const [cancelledBookingsList, setCancelledBookingsList] = useState([]);
  const [holdBookingsList, setHoldBookingsList] = useState([]);
  const [rolledbackBookingsList, setRolledbackBookingsList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(CONFIRM);
  const [showTransactionsList, setShownTransactionsList] = useState(
    confirmedBookingsList,
  );

  useEffect(() => {
    setTransactionsList(hotelBookings);
  }, [hotelBookings]);

  useEffect(() => {
    const canxList = transactionsList.filter(
      (transaction) =>
        (transaction.booking_status || '').toLowerCase() === 'cancelled',
    );
    const rolledBackList = transactionsList.filter(
      (transaction) =>
        (transaction.booking_status || '').toLowerCase() === 'rolledback',
    );
    const confirmList = transactionsList.filter(
      (transaction) =>
        (transaction.booking_status || '').toLowerCase() === 'confirm',
    );
    const holdList = transactionsList.filter(
      (transaction) =>
        (transaction.booking_status || '').toLowerCase() === 'onhold',
    );

    setConfirmedBookingsList(confirmList);
    setCancelledBookingsList(canxList);
    setHoldBookingsList(holdList);
    setRolledbackBookingsList(rolledBackList);
    if (selectedTab === CONFIRM) {
      setShownTransactionsList(confirmList);
    } else if (selectedTab === CANCELLED) {
      setShownTransactionsList(canxList);
    } else if (selectedTab === ONHOLD) {
      setShownTransactionsList(holdList);
    } else if (selectedTab === ROLLEDBACK) {
      setShownTransactionsList(rolledBackList);
    }
  }, [transactionsList]);

  const getShownResults = () => {
    if (selectedTab === CONFIRM) {
      setShownTransactionsList(confirmedBookingsList);
    } else if (selectedTab === CANCELLED) {
      setShownTransactionsList(cancelledBookingsList);
    } else if (selectedTab === ONHOLD) {
      setShownTransactionsList(holdBookingsList);
    } else if (selectedTab === ROLLEDBACK) {
      setShownTransactionsList(rolledbackBookingsList);
    }
  };

  useEffect(() => {
    getShownResults();
  }, [selectedTab]);

  const setSearchResults = debounce((val) => {
    let data = [...hotelBookings];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  return (
    <section className="flight-booking-list-page">
      <div className="train-search-container">
        <div className="mb-2 d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="d-flex gap-2 flight-booking-list-page_transactions-type-container">
        <span
          onClick={() => setSelectedTab(CONFIRM)}
          className={`${selectedTab === CONFIRM ? 'selected-tx-tab' : ''}`}
        >
          Confirmed ({confirmedBookingsList.length})
        </span>
        <span
          onClick={() => setSelectedTab(ONHOLD)}
          className={`${selectedTab === ONHOLD ? 'selected-tx-tab' : ''}`}
        >
          Hold ({holdBookingsList.length})
        </span>
        <span
          onClick={() => setSelectedTab(CANCELLED)}
          className={`${selectedTab === CANCELLED ? 'selected-tx-tab' : ''}`}
        >
          Cancelled({cancelledBookingsList.length})
        </span>
        <span
          onClick={() => setSelectedTab(ROLLEDBACK)}
          className={`${selectedTab === ROLLEDBACK ? 'selected-tx-tab' : ''}`}
        >
          Unsuccessful({rolledbackBookingsList.length})
        </span>
      </div>
      {showTransactionsList.length > 0 ? (
        <div className="hotel-bookings-list_container">
          {showTransactionsList.map((transaction, index) => (
            <HotelBookingsListCard key={index} bookingData={transaction} />
          ))}
        </div>
      ) : (
        <div className="p-3 text-center fw-500">
          <span>No Bookings</span>
        </div>
      )}
    </section>
  );
}

BookingsList.defaultProps = {};

BookingsList.propTypes = {
  hotelBookings: PropTypes.array.isRequired,
};

export default BookingsList;
